<template>
    <v-container fluid ma-3 pa-3>
        <v-layout row wrap justify-center>
            <v-flex>
                <span class="style_title">Edit Startup Information</span>
                <br>
                <br>
                <div>
                    <span class="style_description" style="white-space: pre-line">Startups already registered to Discovery, can propose a modification to their information.

In order to submit the proposal, it is necessary to be in possession of the identification <strong>token</strong> received at the time of registration.
                        The request is protected for security reasons by <strong>Google Captcha</strong>. In order to continue with the update request, you must therefore tick the box "I'm not a robot" and, if requested, solve the proposed challenge.
After clicking on the "Send Update Request" button you will receive an email containing a link to follow in order to edit the details of the startup registered in the Discovery.
The link you will receive is valid for 30 minutes from the moment you request it. When the link expires, it is necessary to repeat the update request.
By clicking on the link in the email you will be directed to a page containing the currently stored startup data. You can edit the fields you want to update and submit the request.
Your proposal will have to be accepted and validated by Discovery admins. If it is accepted, you will receive a confirmation e-mail.
</span>
                </div>
                <br>


            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    export default {
        name: "EditStartupRegistrationHelp",
        components: {},
        data() {
            return {

            }
        },

        methods: {

        }
    }
</script>

<style scoped>
    .style_description{
        font-size: 18px;
    }

    .style_title{
        font-size: 34px;
        font-weight: bold;
    }

</style>